import DictManagement from './DictManagement';

export default DictManagement;
